import { addFabricEventListener } from '../../hooks/useFabricEvent.js';
import Document from '@tiptap/extension-document';
import { PluginKey, Plugin } from '@tiptap/pm/state';
import { FbcDOMSerializer } from '../utils/FbcDOMSerializer.js';
import { scrollToRangeInDoc } from './utils.js';

const FbcDocumentKey = new PluginKey("fbcDocument");
const getFbcDocumentResourceId = (state) => {
  const pluginState = FbcDocumentKey.getState(state);
  if (!pluginState) return void 0;
  return pluginState.resourceId;
};
const FbcDocument = Document.extend({
  content: "block+",
  addCommands() {
    return {
      defineResourceId: (resourceId) => ({ tr }) => {
        tr.setMeta(FbcDocumentKey, {
          resourceId
        });
        return true;
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: FbcDocumentKey,
        view(editorView) {
          let timeout = null;
          const unsub = addFabricEventListener("fabric-keyboard-event", (e) => {
            if (timeout) window.clearTimeout(timeout);
            if (!e.detail.isVisible) return;
            timeout = window.setTimeout(() => {
              const tr = editorView.state.tr.scrollIntoView();
              editorView.dispatch(tr);
            }, 100);
          });
          return {
            destroy() {
              unsub();
            }
          };
        },
        appendTransaction: (transactions, oldState, newState) => {
          let tr = null;
          if (transactions.length > 0) {
            for (const transaction of transactions) {
              if (transaction.getMeta("pointer")) {
                tr = newState.tr.scrollIntoView();
                break;
              }
            }
          }
          return tr;
        },
        state: {
          init() {
            return {
              resourceId: void 0
            };
          },
          apply(tr, value) {
            if (!tr.getMeta(FbcDocumentKey)) return value;
            const meta = tr.getMeta(FbcDocumentKey);
            return {
              ...value,
              resourceId: meta.resourceId
            };
          }
        },
        props: {
          scrollMargin: 40,
          scrollThreshold: 40,
          handleScrollToSelection: (view) => {
            return scrollToRangeInDoc(view, view.state.selection.from, view.state.selection.to);
          },
          handleDOMEvents: {
            touchend: (view) => {
              const initialSelection = view.state.selection;
              setTimeout(() => {
                if (!view.state.selection.eq(initialSelection)) {
                  const tr = view.state.tr.scrollIntoView();
                  view.dispatch(tr);
                }
              }, 100);
            }
          },
          clipboardSerializer: FbcDOMSerializer.fromSchema(this.editor.state.schema)
        }
      })
    ];
  }
});

export { FbcDocument, FbcDocumentKey, getFbcDocumentResourceId };
//# sourceMappingURL=FbcDocument.js.map
